import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component';
import { AuthInitComponent } from './features/auth/auth-init.component';
import { AuthRegisterComponent } from './features/auth/auth-register.component';
import { AuthenticatorRegisterComponent } from './features/auth/authenticator-register.component';
import { SetPasswordComponent } from './features/auth/set-password.component';
import { ForbiddenComponent } from './features/auth/forbidden.component';

export const routes: Routes = [
    // === AUTH ROUTES (no layout) ===
    { path: 'auth/init', component: AuthInitComponent },
    { path: 'auth/set-password', component: SetPasswordComponent },
    { path: 'login', component: AuthInitComponent },
    { path: 'auth/register/authcode/:token', component: AuthRegisterComponent },
    { path: 'auth/register/webauthn/:token', component: AuthRegisterComponent },
    { path: 'auth/register/yubicootp/:token', component: AuthRegisterComponent },
    { path: 'auth/register/authenticator/:token', component: AuthenticatorRegisterComponent },
    { path: 'auth/process/:processId', component: AuthInitComponent },
    {
        path: 'forbidden',
        component: BreadcrumbComponent,
        children: [
            { path: '', component: ForbiddenComponent, data: { title: 'forbidden.title' } },
            { path: 'list', component: ForbiddenComponent, data: { title: 'forbidden.title' } }
        ]
    },

    // === MAIN APP ROUTES (with layout) ===
    {
        path: '',
        component: LayoutComponent,
        children: [
            // DB-seeded menu routes include "resources/" prefix but Angular routes are without it
            { path: 'resources/report_templates/list', redirectTo: 'report_templates/list', pathMatch: 'full' },
            { path: 'resources/report_templates/designer', redirectTo: 'report_templates/designer', pathMatch: 'full' },
            { path: 'dashboards-config', loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.dashboardsConfigRoutes) },
            { path: 'stelia', loadChildren: () => import('./features/stelia/stelia.routes').then(m => m.steliaRoutes) },
            { path: 'dashboards/manage', redirectTo: '/dashboards-config/list', pathMatch: 'full' },
            { path: 'dashboards', redirectTo: '/dashboard', pathMatch: 'full' },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: '', loadChildren: () => import('./features/common/common.routes').then(m => m.commonRoutes) },
            { path: '', loadChildren: () => import('./features/people/people.routes').then(m => m.peopleRoutes) },
            { path: '', loadChildren: () => import('./features/events/events.routes').then(m => m.eventsRoutes) },
            { path: '', loadChildren: () => import('./features/communications/communications.routes').then(m => m.communicationsRoutes) },
            { path: '', loadChildren: () => import('./features/resources/resources.routes').then(m => m.resourcesRoutes) },
            { path: '', loadChildren: () => import('./features/specialized/specialized.routes').then(m => m.specializedRoutes) },
            { path: '', loadChildren: () => import('./features/infrastructure/infrastructure.routes').then(m => m.infrastructureRoutes) },
            { path: '', loadChildren: () => import('./features/faq/faq.routes').then(m => m.faqRoutes) },
            { path: '', loadChildren: () => import('./features/app-install/app-install.routes').then(m => m.appInstallRoutes) },
            { path: '', loadChildren: () => import('./features/notifications/notifications.routes').then(m => m.notificationsRoutes) }
        ]
    },

    // Wildcard - catch all unmatched routes
    { path: '**', redirectTo: 'dashboard' }
];
